import { useEffect } from "react";

import { useLoginAzureAd } from "../azure-ad/api";

import Link from "next/link";

import Divider from "ui-components/Divider";

import config from "config";
import DaishoJWTLogin from "../daisho-jwt/Login";
import FirebaseLogin from "../firebase/Login";

const AzureLogin = () => {
  const azureLogin = useLoginAzureAd();
  useEffect(() => {
    azureLogin();
  }, [azureLogin]);
  return <div></div>;
};

const Login = () => {
  if (config.IDENTITY_PROVIDER === "azure-ad") {
    return <AzureLogin />;
  }
  return (
    <section className="bg-gradient-to-b from-gray-100 to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="pt-32 pb-12 md:pt-40 md:pb-20">
          {/* Page header */}
          <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
            <h1 className="h1">Welcome back. Do More Super Things Today.</h1>
          </div>
          <div className="max-w-sm mx-auto">
            {/* Login Forms */}
            {config.IDENTITY_PROVIDER === "daisho-jwt" && <DaishoJWTLogin />}
            {config.IDENTITY_PROVIDER === "firebase" && <FirebaseLogin />}
            {/* SignUp */}
            {config.SIGN_IN_ALLOWED && (
              <>
                <Divider>Or</Divider>
                <div className="text-gray-600 text-center mt-6">
                  Don’t have an account?{" "}
                  <Link href="/signup">
                    <a className="text-blue-600 hover:underline transition duration-150 ease-in-out">
                      Sign Up
                    </a>
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
